import type { BoardMediaImageError } from "./board-media-image-error-utils";

interface BoardMediaImageErrorListenerDeps {
    error: BoardMediaImageError;
}

class BoardMediaImageErrorListener {
    public error: BoardMediaImageError;

    public constructor(deps: BoardMediaImageErrorListenerDeps) {
        this.error = deps.error;
    }

    public register(): void {
        document.addEventListener(
            "error",
            (event) => {
                this.error.handleImageError(event);
            },
            true,
        );

        globalThis.addEventListener(
            "load",
            () => {
                this.error.replaceAlreadyBrokenImages(document);
            },
            { once: true },
        );
    }
}

export { BoardMediaImageErrorListener };
